import styled from '@emotion/styled';
import {
  Button,
  DatePicker,
  Drawer,
  Form,
  Input,
  notification,
  Select,
  Upload,
} from 'antd';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { FaPlus, FaSearch, FaUpload } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { DetenteurEntity } from '../../../../entities/detenteur.entity';
import { TitreEntity } from '../../../../entities/titre.entity';
import { ORANGE, PRIMARY, YELLOW } from '../../../../shared/colors';
import { formatNum } from '../../../../shared/constants';
import { getYieldToMaturity } from '../../../dashboard/components/OrderEntry';
import { getTitres } from '../../../dashboard/network';
import { createFichier, emissionTitre, getDetenteurs } from '../network';
import { ClientForm } from './ClientForm';

const Container = styled.div`
  margin-top: 12px;

  .issue-form {
    display: grid;
    gap: 12px;
  }

  .form-grid {
    display: grid;
    grid-template-columns: minmax(0, 1.35fr) minmax(420px, 0.85fr);
    gap: 12px;
    align-items: start;
  }

  .form-stack {
    display: grid;
    gap: 12px;
  }

  .form-card {
    overflow: hidden;
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    background: var(--mt-card);
    box-shadow: var(--mt-card-shadow);
  }

  .card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: 44px;
    padding: 10px 14px;
    border-bottom: 1px solid var(--mt-border);
    background: ${PRIMARY};
    color: ${YELLOW};
    font-family: Poppins-B;
    text-transform: uppercase;
  }

  .card-head span:last-of-type {
    color: rgba(255, 247, 232, 0.62);
    font-family: Poppins-R;
    font-size: 11px;
    letter-spacing: 0.06em;
  }

  .card-body {
    padding: 14px;
  }

  .fields-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 12px;
  }

  .field-search {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 38px;
    gap: 8px;
    align-items: end;
  }

  .holder-search {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 38px;
    gap: 8px;
    align-items: end;
  }

  .icon-action {
    height: 38px;
    width: 38px;
    border-color: rgba(255, 176, 0, 0.28);
    border-radius: 999px;
    background: var(--mt-surface);
    color: var(--mt-warning);
  }

  .ant-form-item {
    margin-bottom: 12px;
  }

  .ant-form-item-label {
    padding-bottom: 4px;
  }

  .ant-form-item-label label {
    color: var(--mt-muted);
    font-family: Poppins-B;
    font-size: 11px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .ant-input,
  .ant-picker,
  .ant-select-selector {
    min-height: 38px;
    border-color: var(--mt-border) !important;
    border-radius: 8px !important;
    background: var(--mt-surface) !important;
    color: var(--mt-text) !important;
    box-shadow: none !important;
  }

  .ant-picker {
    width: 100%;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder,
  .ant-picker-input > input,
  .ant-input::placeholder {
    color: var(--mt-muted) !important;
  }

  .upload-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    border: 1px dashed rgba(255, 176, 0, 0.34);
    border-radius: 8px;
    padding: 12px;
    background: var(--mt-surface);
  }

  .upload-card strong {
    display: block;
    color: var(--mt-text);
    font-family: Poppins-B;
  }

  .upload-card span {
    color: var(--mt-muted);
    font-size: 12px;
  }

  .upload-card .ant-btn {
    border-radius: 999px;
    border-color: rgba(255, 176, 0, 0.3);
    color: var(--mt-text);
    background: var(--mt-card);
  }

  .preview-card {
    border-color: rgba(255, 176, 0, 0.26);
  }

  .preview-identity {
    display: grid;
    gap: 4px;
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    padding: 12px;
    background: var(--mt-surface);
  }

  .preview-identity strong {
    color: var(--mt-text);
    font-family: Poppins-B;
    font-size: 20px;
  }

  .preview-identity span {
    color: var(--mt-muted);
    font-size: 12px;
  }

  .preview-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin-top: 10px;
  }

  .preview-row {
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    padding: 9px;
    background: var(--mt-surface);
  }

  .preview-row span {
    display: block;
    color: var(--mt-muted);
    font-size: 10px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  .preview-row strong {
    display: block;
    margin-top: 4px;
    color: var(--mt-text);
    font-family: Poppins-B;
    overflow-wrap: anywhere;
  }

  .preview-row.accent strong {
    color: var(--mt-warning);
  }

  .readiness {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-top: 10px;
    border: 1px solid rgba(255, 176, 0, 0.26);
    border-radius: 8px;
    padding: 10px;
    background: rgba(255, 176, 0, 0.06);
  }

  .readiness strong {
    color: var(--mt-text);
    font-family: Poppins-B;
  }

  .readiness-badge {
    border-radius: 999px;
    padding: 5px 9px;
    font-family: Poppins-B;
    font-size: 11px;
    white-space: nowrap;
  }

  .readiness-badge.ready {
    background: rgba(0, 166, 93, 0.12);
    color: #00965d;
  }

  .readiness-badge.pending {
    background: rgba(255, 176, 0, 0.14);
    color: var(--mt-warning);
  }

  .submit-bar {
    position: sticky;
    bottom: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    padding: 12px 14px;
    background: var(--mt-card);
    box-shadow: var(--mt-card-shadow);
  }

  .submit-bar span {
    color: var(--mt-muted);
    font-size: 12px;
  }

  .submit-button {
    min-width: 220px;
    height: 40px;
    border: 0;
    border-radius: 999px;
    background: linear-gradient(135deg, ${ORANGE}, ${YELLOW});
    color: #07141c;
    font-family: Poppins-B;
  }

  .drawer-title {
    color: var(--mt-text);
    font-family: Poppins-B;
  }

  @media (max-width: 980px) {
    .form-grid,
    .fields-grid,
    .preview-grid {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 640px) {
    .submit-bar {
      align-items: stretch;
      flex-direction: column;
    }

    .submit-button {
      width: 100%;
    }
  }
`;

const PreviewRow = ({
  accent,
  label,
  value,
}: {
  accent?: boolean;
  label: string;
  value: string;
}) => (
  <div className={`preview-row ${accent ? 'accent' : ''}`}>
    <span>{label}</span>
    <strong>{value}</strong>
  </div>
);

export const TitreForm = () => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(true);
  const [showDrawer, setShowDrawer] = useState(false);
  const [detenteurs, setDetenteurs] = useState<DetenteurEntity[]>([]);
  const [titres, setTitres] = useState<TitreEntity[]>([]);
  const [titreCode, setTitreCode] = useState('');
  const [formValues, setFormValues] = useState<any>({ valeurNominale: 10000 });
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;
  const history = useHistory();

  useEffect(() => {
    getDetenteurs(connectedUser.id).then(({ data }) => {
      setDetenteurs(data);
      setIsLoading(false);
    });
    getTitres().then(({ data }) => {
      setTitres(data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const searchTitre = () => {
    let found = titres.find((titre) => titre.code === titreCode);
    if (found) {
      notification.info({ message: 'Un titre avec ce code exist' });
      const foundValues = {
        code: found.code,
        pays: found.pays,
        instrument: found.instrument,
        dureeMaturite: found.dureeMaturite,
        dateEmission: moment(found.dateEmission),
        dateMaturite: moment(found.dateMaturite),
        tauxMarginal: Number(found.tauxMarginal),
        valeurNominale: 10000,
        frequencePaiement: found.frequencePaiement,
      };
      form.setFieldsValue(foundValues);
      setFormValues((values: any) => ({ ...values, ...foundValues }));
    } else {
      notification.info({ message: 'No existing titres' });
    }
  };

  const selectedHolder = useMemo(
    () => detenteurs.find((det) => det.id === formValues.detenteur),
    [detenteurs, formValues.detenteur],
  );

  const issuePreview = useMemo(() => {
    const nominal = Number(formValues.valeurNominale || 0);
    const quantity = Number(formValues.quantite || 0);
    const discount = Number(formValues.decote || 0);
    const coupon = Number(formValues.tauxMarginal || 0);
    const price = nominal ? (nominal * (100 - discount)) / 100 : 0;
    const amount = nominal * quantity;
    const maturityDate = formValues.dateMaturite;
    const issueDate = formValues.dateEmission;
    let yieldToMaturity = 0;

    if (
      nominal > 0 &&
      price > 0 &&
      coupon >= 0 &&
      maturityDate?.format &&
      issueDate?.format
    ) {
      yieldToMaturity =
        Math.round(
          getYieldToMaturity(
            new Date(),
            new Date(maturityDate.format('YYYY-MM-DD')),
            new Date(issueDate.format('YYYY-MM-DD')),
            coupon,
            nominal,
            price,
          ) * 100,
        ) / 100;
    }

    const requiredFields = [
      formValues.code,
      formValues.instrument,
      formValues.pays,
      formValues.dateEmission,
      formValues.dateMaturite,
      formValues.dureeMaturite,
      formValues.tauxMarginal,
      formValues.valeurNominale,
      formValues.frequencePaiement,
      formValues.decote,
      formValues.quantite,
      formValues.detenteur,
      formValues.elementControle,
    ];

    return {
      amount,
      coupon,
      isReady: requiredFields.every((field) => field !== undefined && field !== ''),
      nominal,
      price,
      quantity,
      yieldToMaturity,
    };
  }, [formValues]);

  return (
    <Container>
      <Form
        className='issue-form'
        layout='vertical'
        form={form}
        labelCol={{ span: 20 }}
        wrapperCol={{ span: 25 }}
        initialValues={{ valeurNominale: 10000 }}
        onValuesChange={(_, values) => setFormValues(values)}
        onFinish={async (data) => {
          setIsLoading(true);

          const titreToCreate = {
            code: data.code,
            pays: data.pays,
            instrument: data.instrument,
            dureeMaturite: data.dureeMaturite,
            dateEmission: data.dateEmission.format('YYYY-MM-DD'),
            dateMaturite: data.dateMaturite.format('YYYY-MM-DD'),
            tauxMarginal: Number(data.tauxMarginal),
            valeurNominale: data.valeurNominale,
            frequencePaiement: data.frequencePaiement,
            createur: connectedUser.id,
            agence: connectedUser.agence.id,
          };

          const detailTitreToCreate = {
            parentCode: data.code,
            subCode: data.code + '-1',
            qte: Number(data.quantite),
            montant: data.quantite * data.valeurNominale,
            prixNominale: (data.valeurNominale * (100 - data.decote)) / 100,
            dateAcquisition: moment().format('YYYY-MM-DD'),
            decote: Number(data.decote),
            etat: '',
            originCode: '',
            tauxInteret: Number(data.tauxMarginal),
            tauxRendement:
              Math.round(
                getYieldToMaturity(
                  new Date(),
                  new Date(data.dateMaturite.format('YYYY-MM-DD')),
                  new Date(data.dateEmission.format('YYYY-MM-DD')),
                  data.tauxMarginal as number,
                  data.valeurNominale,
                  (data.valeurNominale * (100 - data.decote)) / 100,
                ) * 100, // round to 2 decimal places
              ) / 100,
            frequence: data.frequencePaiement,
            couponCouruPayer: 0.0,
            couponPercevoir: 0.0,
            commissionTotal: 0.0,
            transaction: null,
            titre: null,
            detenteur: detenteurs.find((det) => det.id === data.detenteur)?.id,
          };

          const compteToCreate = {
            code_svt: connectedUser.partenaire.code_referent,
            code_client: detenteurs.find((det) => det.id === data.detenteur)
              ?.code_referent,
            code_agence: connectedUser.agence.code,
          };

          let schema = '';
          if (data.elementControle.includes('PV')) {
            schema = 'ETPVTR'; // PV Adjudication - titre à recevoir
            detailTitreToCreate.etat = '00';
          } else {
            let codeClient = detenteurs.find(
              (det) => det.id === data.detenteur,
            )?.code_referent;
            if (connectedUser.partenaire.code_referent === codeClient) {
              schema = 'ETNLCP'; // notification de livraison compte propre
              detailTitreToCreate.etat = '01';
            } else {
              schema = 'ETNLCT'; // notification de livraison compte tier
              detailTitreToCreate.etat = '01';
            }
          }

          const dataToCreate = {
            schema,
            titre: titreToCreate,
            // detenteurTitre: detenteurTitreToCreate,
            detailTitre: detailTitreToCreate,
            compte: compteToCreate,
            userId: connectedUser.id,
          };

          await emissionTitre(dataToCreate).then(
            ({ data: newData, statusCode }) => {
              if (statusCode?.toString()[0] === '2') {
                const piece_justif = {
                  nom: data.elementControle,
                  media: data.piece?.fileList[0]?.originFileObj,
                  justif_titre: newData.url,
                };
                createFichier(piece_justif).then(({ data, statusCode }) => {
                  if (statusCode?.toString()[0] === '2') {
                    notification.success({
                      message: 'Succès',
                      description: 'Le titre a été créé avec succès',
                    });
                    history.goBack();
                  } else {
                    notification.info({
                      message: 'Erreur',
                      description: data.message,
                    });
                  }
                  setIsLoading(false);
                });
              } else {
                notification.info({
                  message: 'Erreur',
                  description: newData.message,
                });
                setIsLoading(false);
              }
            },
          );
        }}
      >
        <div className='form-grid'>
          <div className='form-stack'>
            <section className='form-card'>
              <div className='card-head'>
                <span>Identification du titre</span>
                <span>Référentiel marché</span>
              </div>
              <div className='card-body'>
                <div className='field-search'>
                  <Form.Item
                    label='Code du titre'
                    name='code'
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Entrez le code du titre',
                      },
                    ]}
                  >
                    <Input
                      placeholder='Ex. CM110000003'
                      value={titreCode}
                      onChange={(e) => setTitreCode(e.target.value)}
                    />
                  </Form.Item>
                  <Button
                    className='icon-action'
                    icon={<FaSearch />}
                    onClick={() => searchTitre()}
                  />
                </div>
                <div className='fields-grid'>
                  <Form.Item
                    label='Instrument'
                    name='instrument'
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: "Sélectionnez l'instrument",
                      },
                    ]}
                  >
                    <Select placeholder="Sélectionnez l'instrument">
                      <Select.Option value='OTA'>OTA</Select.Option>
                      <Select.Option value='BTA'>BTA</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label='Pays émetteur'
                    name='pays'
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Sélectionnez le pays emetteur',
                      },
                    ]}
                  >
                    <Select placeholder='Sélectionnez le pays emetteur'>
                      <Select.Option value='Cameroun'>Cameroun</Select.Option>
                      <Select.Option value='Tchad'>Tchad</Select.Option>
                      <Select.Option value='Congo'>Congo</Select.Option>
                      <Select.Option value='Gabon'>Gabon</Select.Option>
                      <Select.Option value='Centrafrique'>Centrafrique</Select.Option>
                      <Select.Option value='Guinée Eq.'>
                        Guinée Equatoriale
                      </Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Date d'émission"
                    name='dateEmission'
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: "Entrez la date d'emission",
                      },
                    ]}
                  >
                    <DatePicker placeholder="Entrez la date d'émission" />
                  </Form.Item>
                  <Form.Item
                    label='Date de maturité'
                    name='dateMaturite'
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Entrez la date de maturité',
                      },
                    ]}
                  >
                    <DatePicker placeholder='Entrez la date de maturité' />
                  </Form.Item>
                </div>
              </div>
            </section>

            <section className='form-card'>
              <div className='card-head'>
                <span>Caractéristiques financières</span>
                <span>Pricing primaire</span>
              </div>
              <div className='card-body'>
                <div className='fields-grid'>
                  <Form.Item
                    label='Durée de maturité (mois)'
                    name='dureeMaturite'
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Entrez la durée de maturité du titre',
                      },
                    ]}
                  >
                    <Input
                      placeholder='Ex. 48'
                      type='number'
                      min={0}
                    />
                  </Form.Item>
                  <Form.Item
                    label='Coupon'
                    name='tauxMarginal'
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Entrez le coupon du titre',
                      },
                    ]}
                  >
                    <Input
                      placeholder='Ex. 5.75'
                      type='number'
                      min={0}
                      step={0.01}
                    />
                  </Form.Item>
                  <Form.Item
                    label='Valeur nominale'
                    name='valeurNominale'
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Entrez la valeur nominale du titre',
                      },
                    ]}
                  >
                    <Input
                      placeholder='Ex. 10000'
                      type='number'
                      min={0}
                    />
                  </Form.Item>
                  <Form.Item
                    label='Fréquence de paiement'
                    name='frequencePaiement'
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Sélectionnez la fréquence de paiement du titre',
                      },
                    ]}
                  >
                    <Select placeholder='Sélectionnez la fréquence'>
                      <Select.Option value='Annuelle'>Annuelle</Select.Option>
                      <Select.Option value='Semestrielle'>Semestrielle</Select.Option>
                      <Select.Option value='Trimestrielle'>
                        Trimestrielle
                      </Select.Option>
                      <Select.Option value='Infine'>Infine</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label='Décote'
                    name='decote'
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Entrez la décote du titre',
                      },
                    ]}
                  >
                    <Input
                      placeholder='Ex. 4'
                      type='number'
                      min={0}
                      step={0.01}
                    />
                  </Form.Item>
                  <Form.Item
                    label='Quantité achetée'
                    name='quantite'
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Entrez la quantité du titre',
                      },
                    ]}
                  >
                    <Input
                      placeholder='Ex. 500'
                      type='number'
                      min={0}
                    />
                  </Form.Item>
                </div>
              </div>
            </section>
          </div>

          <aside className='form-stack'>
            <section className='form-card'>
              <div className='card-head'>
                <span>Détenteur</span>
                <span>Compte client</span>
              </div>
              <div className='card-body'>
                <div className='holder-search'>
                  <Form.Item
                    label='Client détenteur'
                    name='detenteur'
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Sélectionnez le détenteur du titre',
                      },
                    ]}
                  >
                    <Select placeholder='Sélectionnez le détenteur'>
                      {detenteurs.map((det) => (
                        <Select.Option key={det.id} value={det.id}>
                          {`${det.code_referent} - ${det.nom} ${det.prenom || ''}`}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Button
                    className='icon-action'
                    icon={<FaPlus />}
                    onClick={() => setShowDrawer(true)}
                  />
                </div>
              </div>
            </section>

            <section className='form-card preview-card'>
              <div className='card-head'>
                <span>Aperçu d'émission</span>
                <span>Temps réel</span>
              </div>
              <div className='card-body'>
                <div className='preview-identity'>
                  <strong>{formValues.code || '--'}</strong>
                  <span>
                    {[formValues.pays, formValues.instrument]
                      .filter(Boolean)
                      .join(' · ') || 'Pays et instrument à renseigner'}
                  </span>
                </div>
                <div className='preview-grid'>
                  <PreviewRow
                    label='Quantité'
                    value={formatNum(issuePreview.quantity) || '--'}
                  />
                  <PreviewRow
                    label='Valeur nominale'
                    value={`${formatNum(issuePreview.nominal) || '--'} XAF`}
                  />
                  <PreviewRow
                    label='Montant global'
                    value={`${formatNum(issuePreview.amount) || '--'} XAF`}
                    accent
                  />
                  <PreviewRow
                    label='Prix après décote'
                    value={`${formatNum(issuePreview.price) || '--'} XAF`}
                  />
                  <PreviewRow
                    label='Coupon'
                    value={`${formatNum(issuePreview.coupon) || '--'}%`}
                  />
                  <PreviewRow
                    label='Rendement estimé'
                    value={
                      issuePreview.yieldToMaturity
                        ? `${formatNum(issuePreview.yieldToMaturity)}%`
                        : '--'
                    }
                  />
                  <PreviewRow
                    label='Détenteur'
                    value={
                      selectedHolder
                        ? `${selectedHolder.code_referent} - ${selectedHolder.nom}`
                        : '--'
                    }
                  />
                  <PreviewRow
                    label='Contrôle'
                    value={formValues.elementControle || '--'}
                  />
                </div>
                <div className='readiness'>
                  <strong>Statut du dossier</strong>
                  <span
                    className={`readiness-badge ${
                      issuePreview.isReady ? 'ready' : 'pending'
                    }`}
                  >
                    {issuePreview.isReady ? 'Prêt à enregistrer' : 'Champs manquants'}
                  </span>
                </div>
              </div>
            </section>

            <section className='form-card'>
              <div className='card-head'>
                <span>Contrôle & justificatif</span>
                <span>Back-office</span>
              </div>
              <div className='card-body'>
                <Form.Item
                  label='Élément de contrôle'
                  name='elementControle'
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: 'Sélectionnez un élément de contrôle',
                    },
                  ]}
                >
                  <Select placeholder='Sélectionnez un élément de contrôle'>
                    <Select.Option value='PV Adjudication Marché Monétaire'>
                      PV Adjudication Marché Monétaire
                    </Select.Option>
                    <Select.Option value='Notification de livraison de titres de la CRCT'>
                      Notification de livraison de titres de la CRCT
                    </Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item label='Pièces justificatives' name='piece'>
                  <div className='upload-card'>
                    <div>
                      <strong>Document de contrôle</strong>
                      <span>PV, notification CRCT ou pièce équivalente.</span>
                    </div>
                    <Upload name='piece'>
                      <Button icon={<FaUpload style={{ marginRight: 8 }} />}>
                        Ajouter
                      </Button>
                    </Upload>
                  </div>
                </Form.Item>
              </div>
            </section>
          </aside>
        </div>

        <Form.Item className='submit-bar'>
          <span>
            Les données saisies alimentent le registre titre, la position du
            détenteur et le schéma de livraison.
          </span>
          <Button
            htmlType='submit'
            loading={isLoading}
            className='submit-button'
          >
            Enregistrer l'émission
          </Button>
        </Form.Item>
      </Form>

      <Drawer
        title={<span className='drawer-title'>Ajouter un nouveau client</span>}
        placement='right'
        width={520}
        onClose={() => setShowDrawer(false)}
        open={showDrawer}
        closeIcon={<MdClose size={20} />}
      >
        <ClientForm
          setShowDrawer={setShowDrawer}
          getNewClient={(cli) => setDetenteurs([...detenteurs, cli])}
        />
      </Drawer>
    </Container>
  );
};
